<template>
  <router-view v-if="!$route.meta.keepAlive" class="app_conetnt" :style="{ 'height': clientHeight + 'px' }" />
  <KeepAlive>
    <router-view v-if="$route.meta.keepAlive" class="app_conetnt" :style="{ 'height': clientHeight + 'px' }" />
  </KeepAlive>
</template>
<script >
import axios from "../src/commons/AxiosMethod.js"

export default {
  data () {
    return {
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight
    }
  },
  name: "App",
  mounted () {
    sessionStorage.setItem("ApiUrl", window.envs.ApiUrl)
    sessionStorage.setItem("Title", window.envs.Title)
    sessionStorage.setItem("Icon", window.envs.Icon)

    document.getElementsByTagName('title')[0].innerText = window.envs.Title
  },
  components: {},
  methods: {

    tabSwitch (item, index) {
      console.log(item, index)
    }
  }
}
</script>

<style lang="scss" >
.app_conetnt {
  height: 100%;
  background-color: rgb(248, 248, 248);

  // max-width: 1920px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  // height: 100%;
  // color: #6d7f90;
  // width: 100%;
  // background-color: rgb(248, 248, 248);

}

body {
  padding: 0px;
  margin: 0px;
}
</style>
